import elementClosest from 'element-closest';
import React, { useState, useEffect } from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import { Card, CardBody } from 'reactstrap';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import CalendarEventModal from './Components/Modals/calendarEventModal';
import * as calendarService from '../Application/Services/calendarService';
import HelpModal from './Components/Modals/helpModal';
import { Trans } from 'react-i18next';
import { convertDateFormatForCalendar } from './Helpers/dateTimeHelper';
import { isCompanyVerified } from './Helpers/companyHelper';
import { useTranslation } from 'react-i18next';

elementClosest(window);
const DragAndDropCalendar = withDragAndDrop(Calendar);

const Cldr = () => {
  const [events, setEvents] = useState([]);
  const [calendarEvent, setCalendarEvent] = useState({});
  const [modalPurpose, setModalPurpose] = useState('');
  const [isCalendarEventModalOpen, setIsCalendarEventModalOpen] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchEvents = async () => {
      const { data: calendarEvents } = await calendarService.getEventsForTheMonth();
      calendarEvents.forEach((calendarEvent) => convertDateFormatForCalendar(calendarEvent));
      setEvents((prevEvents) => [...prevEvents, ...calendarEvents]);
    };
    fetchEvents();
  }, []);

  const toggleHelpModal = () => {
    setShowHelpModal(!showHelpModal);
  };

  const toggle = (purpose) => {
    if (!isCompanyVerified(t)) {
      return;
    }
    setModalPurpose(purpose);
    setIsCalendarEventModalOpen(!isCalendarEventModalOpen);
  };

  const parseStyleProp = ({ style }) => (style ? { style } : {});

  const selectEvent = (event) => {
    toggle('edit');
    setCalendarEvent(event);
    if (event.url) alert(`Event can redirect to: ${event.url}`);
  };

  const handleEmptySelect = ({ start, end }) => {
    toggle('create');
    setCalendarEvent({ start, end, title: '', id: '', description: '' });
  };

  const moveEvent = async ({ event, start, end }) => {
    updateEvent(event.id, start, end, event.title, event.description, event.attendees);
  };

  const resizeEvent = async ({ event, start, end }) => {
    updateEvent(event.id, start, end, event.title, event.description, event.attendees);
  };

  const onDelete = async (calendarEventId) => {
    toggle('close');
    const originalEvents = [...events];
    const updatedEvents = originalEvents.filter((e) => e.id !== calendarEventId);
    setEvents(updatedEvents);

    try {
      await calendarService.deleteCalendarEvent(calendarEventId);
    } catch (error) {
      setEvents(originalEvents);
    }
  };

  const createEvent = async (start, end, title, description, attendees) => {
    let { data: newEvent } = await calendarService.createCalendarEvent({ start, end, title, description, attendees });

    newEvent = convertDateFormatForCalendar(newEvent);
    if (newEvent) {
      setEvents((prevEvents) => [...prevEvents, newEvent]);
    }
  };

  const updateEvent = async (id, start, end, title, description, attendees) => {
    let { data: updatedEvent } = await calendarService.updateCalendarEvent({
      id,
      start,
      end,
      title,
      description,
      attendees,
    });

    if (updatedEvent) {
      updatedEvent = convertDateFormatForCalendar(updatedEvent);
      setEvents((prevEvents) => prevEvents.map((event) => (event.id === updatedEvent.id ? updatedEvent : event)));
    }
  };

  const handleValidCalendarEventSubmit = (values) => {
    if (values.calendarEventId === '') {
      createEvent(
        values.calendarEventTimeStart,
        values.calendarEventTimeEnd,
        values.calendarEventTitle,
        values.notesTextArea,
        values.asyncSelectAttendees
      );
    } else {
      updateEvent(
        values.calendarEventId,
        values.calendarEventTimeStart,
        values.calendarEventTimeEnd,
        values.calendarEventTitle,
        values.notesTextArea,
        values.asyncSelectAttendees
      );
    }
    toggle('close');
  };

  return (
    <ContentWrapper>
      <CalendarEventModal
        calendarEvent={calendarEvent}
        showCalendarEventModal={isCalendarEventModalOpen}
        onHandleValidSubmit={handleValidCalendarEventSubmit}
        onToggle={toggle}
        onDelete={onDelete}
        modalPurpose={modalPurpose}
      />
      <div className="content-heading">
        <div>
          <Trans i18nKey="calendar.CALENDAR" />
          {/* <HelpModal purpose="calendarHelp" showModal={showHelpModal} onToggle={toggleHelpModal} /> */}
          <small>
            <Trans i18nKey="calendar.DESCRIPTION" />
          </small>
        </div>
      </div>
      <div className="calendar-app">
        <Card className="card-default">
          <CardBody>
            <DragAndDropCalendar
              localizer={momentLocalizer(moment)}
              style={{ minHeight: 600 }}
              selectable
              events={events}
              onEventDrop={moveEvent}
              resizable
              onEventResize={resizeEvent}
              onSelectEvent={selectEvent}
              defaultView="week"
              defaultDate={new Date()}
              eventPropGetter={parseStyleProp}
              onSelectSlot={handleEmptySelect}
            />
          </CardBody>
        </Card>
      </div>
    </ContentWrapper>
  );
};

export default Cldr;
